import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { RANK_TIERS } from "./userRankConfig";
import { recordUserEvent, USER_EVENT_TYPES } from "./userEvents";

export const calculateRankProgression = async (userId) => {
  const userStatsRef = doc(db, "userStats", userId);

  try {
    const userStatsDoc = await getDoc(userStatsRef);
    if (userStatsDoc.exists()) {
      const data = userStatsDoc.data();
      const totalPoints = data.points.total || 0;
      const previousRank = data.rank?.current || "Rookie";

      let currentRank = "Rookie";
      let nextRank = "Scout";
      let progress = 0;

      for (let i = 0; i < RANK_TIERS.length; i++) {
        const tier = RANK_TIERS[i];
        if (totalPoints < tier.maxPoints) {
          currentRank = tier.name;
          nextRank = RANK_TIERS[i + 1]?.name || tier.name;
          progress = Math.round(((totalPoints - (RANK_TIERS[i - 1]?.maxPoints || 0)) /
            (tier.maxPoints - (RANK_TIERS[i - 1]?.maxPoints || 0))) *
            100);
          break;
        }
      }

      // Update the rank information in Firestore
      await updateDoc(userStatsRef, {
        "rank.current": currentRank,
        "rank.next": nextRank,
        "rank.progress": progress,
      });

      // Check if rank has changed and record a rank-up event if it has
      if (previousRank !== currentRank) {
        // Get the tier information for more detailed event data
        const currentTierIndex = RANK_TIERS.findIndex(tier => tier.name === currentRank);
        const currentTier = RANK_TIERS[currentTierIndex];
        
        await recordUserEvent(userId, USER_EVENT_TYPES.RANK_UP, {
          oldRank: previousRank,
          newRank: currentRank,
          totalPoints,
          rankIndex: currentTierIndex,
          pointsForNextRank: nextRank !== currentRank ? 
            RANK_TIERS[currentTierIndex + 1]?.maxPoints - totalPoints : 0
        });
        
        console.log(
          `🏆 User ${userId} ranked up from ${previousRank} to ${currentRank}!`
        );
      }

      console.log(
        `Rank updated for user ${userId}: ${currentRank} (${progress}% progress toward ${nextRank})`
      );
      
      return {
        currentRank,
        nextRank,
        progress,
        isRankUp: previousRank !== currentRank
      };
    }
  } catch (error) {
    console.error("Error calculating rank progression:", error.message);
    return null;
  }
};